// Login Screen module Selectors
export const getDefaultLoginForm = ({ loginForm }) => loginForm.loginForm;
export const isLoading = ({ loginForm }) => loginForm.loading;
export const isError404 = ({ loginForm }) => loginForm.error;
export const getAlertModalData = ({ loginForm }) => loginForm.alert;

// Status Screen module Selectors
export const getDefaultStatusForm = ({ statusForm }) => statusForm.statusForm;
export const isTableLoading = ({ statusForm }) => statusForm.loading;
export const Error404 = ({ statusForm }) => statusForm.error

export const validateForm = (values) => {
    let errors = {};

    if (values.CompleteName.trim() === '') {
        errors[`CompleteName`] = 'Complete Name is required!'
    }

    if (values.ApplicantCode.trim() === '') {
        errors[`ApplicantCode`] = 'Applicant Code is required!'
    }

    return errors;
}